import React, {Component} from 'react'
import {getStepByIndex, getStepIndexByUrl, updateStepProgress, updateDBStepProgress} from '../../helpers/steps'
import {getReferences, getSoneFundingByCourseSSPNo, getSonePersonalDetails, getStudentProgress, putSoneFundingDetails} from '../../services/vu'
import {getCourseId} from '../../helpers/course'
import Loading from '../tags/Loading'
import {differenceInSeconds, isBefore} from 'date-fns'
import {getLastPageAccessTime} from '../../helpers/gtm'
import {getAttributeCourseStaticInfo, isStudentOnLeave} from '../../helpers/enrolment'
import FinanceContainer from "../tags/FinanceContainer";

export default class FinancialSupport extends Component {
  constructor(props) {
    super(props)

    this.state = {
      attemptedToSubmit: false,
      submitting: false,
      isTitleModalOpen: false,
      isAbleToEdit: true,
      fundingInfo: null,
      personalDetails: {},
      fundingApiFailed: false,
      loaded: false,
      isStudyPlanExpanded: false,
    }
  }

  componentDidMount() {
    getSonePersonalDetails().then( personalDetails => {
      Promise.all([getSoneFundingByCourseSSPNo(getAttributeCourseStaticInfo('courseSSPNo'), getAttributeCourseStaticInfo('liabilityCategoryCode'), personalDetails.stuCitizenCd) ])
        .then(
          ([
             fundingInfo
           ]) => {
            this.stopLoading({
              fundingInfo: fundingInfo,
              personalDetails: personalDetails,
              isStudyPlanExpanded: getAttributeCourseStaticInfo('isStudyPlanExpanded') === 'Y'
            })
          })
        .catch(() => {
          this.stopLoading({
            fundingApiFailed: true,
            isStudyPlanExpanded: getAttributeCourseStaticInfo('isStudyPlanExpanded') === 'Y'
          })
        })
    })
  }

  stopLoading = (newState = {}) => {
    this.setState({
      loaded: true,
      ...newState
    })
  }

  trackPageView = () => {
    getStudentProgress(getCourseId()).then(progress => {
      const processId = progress && progress.id ? progress.id : undefined

      const lastPageAccessTime = getLastPageAccessTime()
      const pageAccessTime = new Date()

      window.dataLayer.push({
        event: 'custom.form.step.view',
        group: 'Enrol',
        processId: processId,
        step: {
          sequence: 4,
          label: 'Financial support',
          variation: undefined
        },
        info: {
          time: lastPageAccessTime
            ? differenceInSeconds(pageAccessTime, new Date(lastPageAccessTime))
            : undefined
        },
        data: {
          value: undefined,
          courseId: getCourseId()
        }
      })

      sessionStorage.setItem(
        'LAST_PAGE_ACCESS_TIME',
        JSON.stringify(pageAccessTime)
      )
    })
  }

  progressForm = () => {
    const currentStepIndex = getStepIndexByUrl(this.props.location.pathname)

    updateStepProgress(currentStepIndex)
    updateDBStepProgress(currentStepIndex)

    this.props.history.push(getStepByIndex(currentStepIndex + 1).url)
  }

  render() {
    if (!this.state.loaded) {
      return (
        <Loading />
      )
    }

    return (
      <FinanceContainer
        isStudyPlanExpanded={this.state.isStudyPlanExpanded}
        fundingInfo={this.state.fundingInfo}
        personalDetails={this.state.personalDetails}
        fundingApiFailed={this.state.fundingApiFailed}
        isAbleToEdit={this.state.isAbleToEdit}
        successFinish={this.progressForm}
      />
    )
  }
}
